import React from "react";
import {connect} from "src/store";
import isEqual from "lodash-es/isEqual";
import Source from "./Source";
import debounce from "../../../../../utils/debounce";

export class TillBasedSource extends React.Component {

    constructor(props) {
        super(props);
        this.change = debounce((field, value) => {
            props.setFieldValue && props.setFieldValue(field, value);
        }, 300);
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const {props} = {...this.props};
        if (prevProps.till?.id + "" !== "" + this.props.till?.id || props.getValue("source")?.id !== this.props.till?.pos?.location?.id) {
            this.change("source", this.props.till?.pos?.location || null);
        }
    }

    getProps = (name) => {
        const {props} = {...this.props};
        const fieldProps = props.getProps(name);
        fieldProps.disabled = true;
        return fieldProps;
    }

    render() {
        const propsTop = {...this.props};
        const {props, state, parent} = propsTop;
        const {hidden, labels, pool, operationitems} = props;
        return (hidden || []).indexOf("source") === -1 && <Source
            {...{...propsTop, props: {...propsTop.props, getProps: this.getProps}}} visible={this.props.visible} />;
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(TillBasedSource);